export const HOME_PERSON_GRID_SKELETON_COUNT = 8;
